import { Reveal } from "./Reveal";

export default function Manifesto() {
    return (
        <section
            id="manifest"
            data-testid="manifesto"
            className="px-6 pb-36 pt-0 md:px-12 md:pb-56"
        >
            <div className="mx-auto max-w-5xl">
                <Reveal>
                    <span className="eyebrow">Manifest</span>
                </Reveal>
                <Reveal delay={0.1}>
                    <p
                        className="mt-10 font-serif font-light leading-[1.1]"
                        style={{ fontSize: "clamp(2.1rem, 5vw, 4rem)" }}
                    >
                        Credem că părul frumos nu se grăbește. Fiecare nuanță este
                        gândită, fiecare fir respectat.{" "}
                        <span style={{ color: "var(--accent)" }}>
                            La LadyArt lucrăm încet, cu grijă și cu intenție
                        </span>{" "}
                        — pentru un rezultat care rămâne elegant mult după ce
                        pleci din salon.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
